define('common/components/comet/behaviors/take-over-modal-behavior',[], function () {
    "use strict";

    return Mn.Behavior.extend({

        "initialize": function(){
            this.listenTo(Backbone.Radio.channel('learn-router'), {
                'window:resize': this.resizeModal
            });

            $(document.body).on('keydown.modal', $.proxy(this._onKeydown, this));

            setTimeout(_.bind(function(){
                this.focusFirst({}, true);
            }, this), 1);
        },

        "onAttach": function(){
            this.resizeModal();
        },

        "onRender": function(){
            setTimeout(_.bind(this.resizeModal, this), 1);
        },


        "focusFirst": function(e, skipDismissButton) {
            var focusableEls = this.view.$el.find(":focusable").not('.js-focus-fence');

            if (skipDismissButton && focusableEls.length > 1) {
                // When the modal first loads, avoid highlighting the dismiss button if possible
                focusableEls = focusableEls.filter(':not([data-trigger="dismiss"])');
            }

            // Find first focusable element in modal and apply focus to it
            focusableEls.first().focus();
        },

        "resizeModal": function(){
            var $resizeModal = this.$('.comet-modal'),
                $modalInner = $resizeModal.find('.comet-modal__inner'),
                $modalContent = $resizeModal.find('.comet-modal__content'),
                $modalHeaderHeight = $resizeModal.find('.comet-modal__header').height(),
                $modalFooterHeight = $resizeModal.find('.comet-modal__footer').outerHeight(),
                availableHeight = window.innerHeight,
                $newHeight;

            if ($modalInner.length > 0) {
                $newHeight = availableHeight - ($modalHeaderHeight + $modalFooterHeight + 80); // 80 is for misc spacing and margins
                if ($newHeight > 775) { $newHeight = 775; }
                $modalContent.css('max-height', $newHeight);

                if ($modalContent.get(0).scrollHeight > $modalContent.innerHeight()) {
                    $modalInner.addClass("comet-modal--scrollable");
                } else {
                    $modalInner.removeClass("comet-modal--scrollable");
                }
            }
        },

        "_trapFocus": function() {
            // Add a "focus fence" around the modal. If one of these elements receives focus,
            // prevent the user from escaping the modal and wrap focus instead.
            $('<div />').attr('tabindex', 0).addClass('js-focus-fence')
                .prependTo(this.$el)
                .on('focus', $.proxy(this.focusLast, this));

            $('<div />').attr('tabindex', 0).addClass('js-focus-fence')
                .appendTo(this.$el)
                .on('focus', $.proxy(this.focusFirst, this));
        }

    });
});

